import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component TextStyleBoldIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <TextStyleBoldIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <TextStyleBoldIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const TextStyleBoldIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="TextStyleBoldIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M19.53 15.65Q19.53 16.94 19.02 17.86Q18.5 18.79 17.6 19.37Q16.7 19.96 15.5 20.23Q14.31 20.5 12.97 20.5H4.47V3.5H12.25Q13.76 3.5 14.93 3.76Q16.11 4.02 16.92 4.55Q17.72 5.08 18.14 5.88Q18.56 6.69 18.56 7.77Q18.56 9.22 17.76 10.21Q16.95 11.21 15.31 11.56Q17.38 11.8 18.45 12.86Q19.53 13.91 19.53 15.65ZM14.97 8.25Q14.97 7.11 14.24 6.62Q13.51 6.14 12.08 6.14H8.02V10.35H12.1Q13.61 10.35 14.29 9.83Q14.97 9.3 14.97 8.25ZM15.96 15.37Q15.96 14.7 15.7 14.24Q15.43 13.78 14.97 13.5Q14.5 13.22 13.88 13.1Q13.26 12.98 12.54 12.98H8.02V17.86H12.67Q13.37 17.86 13.97 17.74Q14.58 17.63 15.02 17.34Q15.46 17.06 15.71 16.58Q15.96 16.1 15.96 15.37Z"
        clipRule="evenodd"
      />
    </svg>
  )
);
TextStyleBoldIcon.displayName = "TextStyleBoldIcon";
export default TextStyleBoldIcon;
